import { useModal } from '@/shared/context/ModalContext';
import TenantModal from '@/feature/Tenant/components/TenantModal';
import MemberModal from '@/feature/Users/components/MemberModal';
import ChannelModal from '@/feature/Rules/components/modal/ChannelModal.jsx';
import RuleModal from '@/feature/Rules/components/modal/RuleModal.jsx';
import AssignChannelModal from '@/feature/Rules/components/modal/AssignChannelModal.jsx';
import GatewayModal from '@/feature/Gateway/components/GatewayModal';
import DeviceModal from '@/feature/Devices/components/DeviceModal';
import DeviceDashboardsModal from '@/feature/Devices/components/DeviceDashboardsModal.jsx';
import DeleteConfirmModal from '@/shared/components/modals/DeleteConfirmModal';
import BarcodeScanner from '@/shared/components/modals/BarcodeScanner';
import FolderModal from '@/feature/Dashboard/components/modal/FolderModal.jsx';
import MoveDashboardModal from '@/feature/Dashboard/components/modal/MoveDashboardModal.jsx';
import RenameDashboardModal from '@/feature/Dashboard/components/modal/RenameDashboardModal.jsx';
import TagModal from '@/shared/components/modals/TagModal.jsx';

const ModalContainer = () => {
  const { isModalOpen, closeModal, getModalData, isModalLoading } = useModal();

  return (
    <>
      {/* Tenant Modal */}
      <TenantModal
        isOpen={isModalOpen('tenantModal')}
        onClose={() => closeModal('tenantModal')}
        onSubmit={getModalData('tenantModal')?.onSubmit}
        tenant={getModalData('tenantModal')?.tenant}
        isLoading={isModalLoading('tenantModal')}
      />

      {/* Member Modal */}
      <MemberModal
        isOpen={isModalOpen('memberModal')}
        onClose={() => closeModal('memberModal')}
        onSubmit={getModalData('memberModal')?.onSubmit}
        member={getModalData('memberModal')?.member}
        isLoading={isModalLoading('memberModal')}
      />

      {/* Gateway Modal */}
      <GatewayModal
        isOpen={isModalOpen('gatewayModal')}
        onClose={() => closeModal('gatewayModal')}
        onSubmit={getModalData('gatewayModal')?.onSubmit}
        gateway={getModalData('gatewayModal')?.gateway}
        isLoading={isModalLoading('gatewayModal')}
      />

      {/* Device Modal */}
      <DeviceModal
        isOpen={isModalOpen('deviceModal')}
        onClose={() => closeModal('deviceModal')}
        onSubmit={getModalData('deviceModal')?.onSubmit}
        device={getModalData('deviceModal')?.device}
        isLoading={isModalLoading('deviceModal')}
      />

      <DeviceDashboardsModal
        isOpen={isModalOpen('deviceDashboards')}
        onClose={() => closeModal('deviceDashboards')}
        onOpenDashboard={getModalData('deviceDashboards')?.onOpenDashboard}
        device={getModalData('deviceDashboards')?.device}
      />

      {/* Channel Modal */}
      <ChannelModal
        isOpen={isModalOpen('channelModal')}
        onClose={() => closeModal('channelModal')}
        onSubmit={getModalData('channelModal')?.onSubmit}
        channel={getModalData('channelModal')?.channel}
        channelTypes={getModalData('channelModal')?.channelTypes || []}
        isLoading={isModalLoading('channelModal')}
      />

      {/* Rule Modal */}
      <RuleModal
        isOpen={isModalOpen('ruleModal')}
        onClose={() => closeModal('ruleModal')}
        onSubmit={getModalData('ruleModal')?.onSubmit}
        rule={getModalData('ruleModal')?.rule}
        isLoading={isModalLoading('ruleModal')}
      />

      {/* Assign Channel Modal */}
      <AssignChannelModal
        isOpen={isModalOpen('assignChannelModal')}
        onClose={() => closeModal('assignChannelModal')}
        onSubmit={getModalData('assignChannelModal')?.onSubmit}
        channels={getModalData('assignChannelModal')?.channels || []}
        isLoading={isModalLoading('assignChannelModal')}
      />

      {/* Barcode Scanner Modal */}
      <BarcodeScanner
        isOpen={isModalOpen('barcodeScanner')}
        onClose={() => closeModal('barcodeScanner')}
        onScan={getModalData('barcodeScanner')?.onScan}
      />

      {/* Folder Modal */}
      <FolderModal
        isOpen={isModalOpen('folderModal')}
        onClose={() => closeModal('folderModal')}
        onSubmit={getModalData('folderModal')?.onSubmit}
        folder={getModalData('folderModal')?.folder}
        isLoading={isModalLoading('folderModal')}
      />

      {/* Move Dashboard Modal */}
      <MoveDashboardModal
        isOpen={isModalOpen('moveDashboard')}
        onClose={() => closeModal('moveDashboard')}
        dashboard={getModalData('moveDashboard')?.dashboard}
        folders={getModalData('moveDashboard')?.folders || []}
        onConfirm={getModalData('moveDashboard')?.onConfirm}
        isLoading={isModalLoading('moveDashboard')}
      />

      {/* Rename Dashboard Modal */}
      <RenameDashboardModal
        isOpen={isModalOpen('renameDashboard')}
        onClose={() => closeModal('renameDashboard')}
        onSubmit={getModalData('renameDashboard')?.onSubmit}
        dashboard={getModalData('renameDashboard')?.dashboard}
        isLoading={isModalLoading('renameDashboard')}
      />

      {/* Unified Delete Confirm Modal */}
      <DeleteConfirmModal
        isOpen={isModalOpen('deleteConfirm')}
        onClose={() => closeModal('deleteConfirm')}
        onConfirm={getModalData('deleteConfirm')?.onConfirm}
        title={getModalData('deleteConfirm')?.title}
        itemName={getModalData('deleteConfirm')?.itemName}
        isLoading={isModalLoading('deleteConfirm')}
      />

      {/* Tag Modal */}
      <TagModal
        isOpen={isModalOpen('tagModal')}
        onClose={() => closeModal('tagModal')}
        entity={getModalData('tagModal')?.entity}
        entityType={getModalData('tagModal')?.entityType}
      />
    </>
  );
};

export default ModalContainer;
